import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

import { Trip } from '../../classes/trip';
import { OVERLAY_PANEL_DATA } from '../../../core/services/overlay-panel';
import { OverlayPanelRef } from '../../../core/services/overlay-panel/overlay-panel-ref';

import { DateRangeSettingComponent } from '../date-range-setting/date-range-setting.component';

import dayjs from 'dayjs';

@Component({
  selector: 'app-date-range-panel',
  templateUrl: './date-range-panel.component.html',
  styleUrl: './date-range-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DateRangeSettingComponent],
})
export class DateRangePanelComponent {
  public isSpecifyDates: boolean;
  public min = dayjs(new Date().toDateString());
  public max = dayjs(new Date().toDateString()).add(4, 'day');
  public duration: number = 7;
  public dateLimit: number = 49;
  public config = [
    {
      label: 'Dates',
      parameter: true,
    },
    {
      label: 'Duration',
      parameter: false,
    },
  ];

  constructor(
    @Inject(OverlayPanelRef) private ref: OverlayPanelRef,
    @Inject(OVERLAY_PANEL_DATA)
    public data: Pick<
      Trip,
      'numDays' | 'isSpecifyDates' | 'tripStartDate' | 'tripEndDate'
    > & { showTypeSelector?: boolean; dateLimit?: number },
  ) {
    if (this.data && this.data.dateLimit) {
      this.dateLimit = this.data.dateLimit;
    }
    if (!this.data.tripStartDate) {
      this.data.tripStartDate = new Date(this.min.toDate());
      this.data.tripEndDate = new Date(this.max.toDate());
      this.data.isSpecifyDates = true;
      this.data.numDays = 12;
      setTimeout(() => {
        this.emittedValuesHandler({
          isAutoEmmit: true,
          isSpecifyDates: true,
          numDays: 12,
          tripStartDate: new Date(this.min.toDate()),
          tripEndDate: new Date(this.max.toDate()),
        });
      }, 250);
    }
  }

  public emittedValuesHandler(payload: any): void {
    this.ref.emitValue(payload);
  }
}
